import type { ToastProps } from '#ui/types';

export function useAppToast() {
  const toast = useToast();

  function showSuccessToast(title = 'Success', description: string = 'The action was completed successfully') {
    return toast.add({
      title,
      description,
      color: 'success',
    });
  }

  function showErrorToast(title = 'Request Failed', description: string = 'Please try again later') {
    return toast.add({
      title,
      description,
      color: 'error',
    });
  }

  function showToast(data: Partial<ToastProps> = {}) {
    const { color, title, description } = data;

    if (color === 'success') {
      showSuccessToast(title as string, description as string);
      return;
    }

    if (color === 'error') {
      showErrorToast(title as string, description as string);
      return;
    }

    toast.add(data);
  }

  return {
    toast,

    showToast,
    showErrorToast,
    showSuccessToast,
  };
}
